// src/components/SEO.js
import React from "react";
import { Helmet } from "react-helmet";

function SEO({
  title = "Pioneer One Global – Expand & Thrive in India with Confidence",
  description = "Global thinking meets local expertise. Pioneer One Global helps businesses explore, enter, and grow in India with smart compliance and cultural fluency.",
  url = "https://www.pioneeroneglobal.com",
  image = "https://www.pioneeroneglobal.com/images/og-home.jpg",
  tmpimage = "https://www.pioneeroneglobal.com/images/og-home.png"
}) {
  return (
    <Helmet>
      {/* SEO Title & Description */}
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph (Facebook, LinkedIn, WhatsApp, etc.) */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={tmpimage} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={tmpimage} />
    </Helmet>
  );
}

export default SEO;
